import React, { FC, useEffect, useState } from 'react'
import styled from 'styled-components'

import {
  ConfigurableProductDetailsFragment,
  MediaGalleryInterface,
  SimpleProductDetailsFragment,
} from '../../../../graphql/magento'
import ItemImage from './ItemImage'
import ItemImagePreviews from './ItemImagePreviews'

import productPlaceholderImage from '../../../../img/product-image-placeholder.png'

export interface ItemImagesProps {
  className?: string
  item: ConfigurableProductDetailsFragment
  selectedVariant: SimpleProductDetailsFragment | null | undefined
}

const ItemImages: FC<ItemImagesProps> = ({ className, item, selectedVariant = null }) => {
  const [selectedImage, setSelectedImage] = useState<MediaGalleryInterface | null | undefined>(
    item.image,
  )
  const [images, setImages] = useState(item.media_gallery)

  useEffect(() => {
    if (selectedVariant?.image) {
      setSelectedImage(selectedVariant.image)
      setImages(selectedVariant.media_gallery)
      return
    }
    setSelectedImage({ url: productPlaceholderImage })
    setImages([{ url: productPlaceholderImage }])
  }, [selectedVariant])

  const showItemImagePreviews = (images?.length ?? 0) > 1

  return (
    <div className={className}>
      <div className="item-images-inner">
        {selectedImage && (
          <ItemImage
            image={selectedImage}
            showItemImagePreviews={showItemImagePreviews}
            className="item-image-container"
          />
        )}
        <ItemImagePreviews
          className="item-image-previews-container"
          images={images || []}
          selectedImage={selectedImage}
          setSelectedImage={setSelectedImage}
          showItemImagePreviews={showItemImagePreviews}
        />
      </div>
    </div>
  )
}

const StyledItemImages = styled(ItemImages)(({ theme }) => ({
  background: theme.colors.coolGray.cool250,
  marginBottom: '25px',
  paddingTop: '45px',
  width: '100%',
  '@media(min-width: 600px)': {
    alignItems: 'flex-start',
    background: theme.colors.coolGray.cool250,
    display: 'flex',
    flexDirection: 'row-reverse',
    // flexWrap: 'no-wrap',
    height: '100%',
    justifyContent: 'flex-end',
    marginBottom: 0,
    maxWidth: '100%',
    paddingBottom: '25px',
    paddingLeft: '25px',
    paddingRight: '25px',
    paddingTop: '75px',
    '.item-images-inner': {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
    },
  },
}))

export default StyledItemImages
